<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        :showEdit="false"
        :title="title"
      />
      <v-dialog
        v-model="open"
        :key="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
      >
        <Form
          ref="formOrder"
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :multiple="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import costCenters from "@/store/centrosDeCosto/costCenters";
import relations from "@/store/autorizaciones/relations";
import Vue from "vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.costCenters"),
      titleTable: "Roles_CsCostos",
      titleDelete: this.$tc("autoriz.toCostCenterRol"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      selectAutoriza: [
        {
          name: "No autoriza",
          value: 0,
        },
        {
          name: "Autoriza",
          value: 1,
        },
        {
          name: "Según autorización previa",
          value: 2,
        },
      ],
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
     await relations.dispatch("getRolCostCenters");
    await costCenters.dispatch("getCostCenters");
    this.isLoading = false;
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !relations.state.costCenters ||
        relations.state.costCenters.length === 0
      ) {
        return []; // Return an empty array when conceptos doesn't exist or is falsy
      } else {
        return relations.state.costCenters?.map((item) => {
          return item
        });
      }
    },

    costCenters() {
      return costCenters.state.costCenters;
    },

    costCentersSelected() {
      const editCost = this.editCostCenters;
      return costCenters.state.costCenters.filter(
        (cost) =>
          !editCost?.some(
            (selected) => selected.id === cost.id
          )
      );
    },
    editCostCenters() {
      return relations.state.costCenters;
    },

    dataSelects() {
      return [
        {
          name: "idConcept",
          label: "Centros de costo",
          data: "",
          items: [],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return relations.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return relations.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return relations.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async triggerSubmit() {
      if (this.$refs.formOrder) {
         this.$refs.formOrder.submitForm();
      }
    },
    async refreshItems() {
      if (relations.state.edit.id) {
        await relations.dispatch("getRolCostCenters");
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.costCentersSelected
;
          this.dataSelects[0].readonly = false;

          relations.commit(
            "setMode",
            this.$tc("autoriz.addCostCenterToRol")
          );
          relations.commit("setOpen", true);
          break;
          this.oldItems = item;
          this.dataSelects[0].data = item.fixed;
          this.dataSelects[0].items = this.selectAutoriza;
          this.dataSelects[1].data = item.id;
          this.dataSelects[1].items = this.concepts;
          this.dataSelects[1].readonly = true;
          relations.commit(
            "setMode",
            this.$tc("autoriz.addCostCenterToRol")
          );
          relations.commit("setOpenFormRelation", true);
          break;
        case "delete":
          relations.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            rolId: relations.state.edit.id,
          };
          break;
        default:
          break;
      }
    },

    reset(value) {
      relations.commit("setOpen", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
        item.items = [];
      });
    },

    saveForm(items) {
      if (this.typeForm ==="add") {
        return  this.addCostCenter(items);
      }
    },

    async addCostCenter(form) {
      let payload = {
         idsCostCenters: form.idConcept.split(',').map(id => parseInt(id, 10)),
        rolId: relations.state.edit.id,
      };
      relations.commit("setNew", payload);
      relations
        .dispatch("addRolCostCenter")
        .then(() => {
          relations.dispatch("getRolCostCenters");
          this.showAlert(
            this.$tc("autoriz.addCostCenterToRolSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("autoriz.errorCostCenter"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },

    deleteItem() {
      relations.commit("setItemDelete", this.itemToDelete);
      relations
        .dispatch("deleteRolCostCenter")
        .then(() => {
          this.openDelete = false;
          relations.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("autoriz.deleteCostCenterToRolSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("autoriz.errorCostCenter"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      relations.commit("setOpenDelete", false);
    },
  },
};
</script>
